<template>
  <Fragment>
    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5">
        Cost of Fuel<br /><span>USD/gallon</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.costOfFuel"
          v-bind="masks.money"
          class="form-control form-control-lg"
          type="text"
          required
          @input="onFieldChange($event, fuel.costOfFuel)"
        />
      </StepInputGroup>
    </div>

    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5">
        Avg. Fuel Mileage<br /><span>MPG</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.tractorMPG"
          v-bind="masks.decimalSinglePrecision"
          required
          class="form-control form-control-lg"
          type="text"
          @input="onFieldChange($event, fuel.tractorMPG)"
        />
      </StepInputGroup>
    </div>
  </Fragment>
</template>

<script>
import { Money } from 'v-money';
import { Fragment } from 'vue-frag';

import StepFieldLabel from '../step-elements/StepFieldLabel.vue';
import StepInputGroup from '../step-elements/StepInputGroup.vue';
import { mapState, mutation, masks } from '../store';
import { defaultFuel } from '../store/state';

export default {
  name: 'Fuel',

  components: { Money, Fragment, StepFieldLabel, StepInputGroup },

  data() {
    return {
      /** @type {Fuel} */
      form: defaultFuel(),
      masks,
    };
  },

  computed: {
    ...mapState({
      /** @returns {Fuel} */
      fuel: (/** @type {ROICalculatorState} */ state) => {
        return state.formValues.fuel;
      },
    }),
  },

  watch: {
    fuel: {
      handler: function (newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }

        this.form = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
    },
  },

  methods: {
    onFieldChange(formValue, stateValue) {
      if (stateValue == formValue) {
        return;
      }

      this.$store.commit(mutation('SET_FUEL_VALUES'), this.form);
    },
  },
};

/**
 * @typedef {import('../store/state').ROICalculatorState} ROICalculatorState
 * @typedef {import('../store/state').Fuel} Fuel
 */
</script>
